// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import Button from 'presentations/views/components/atoms/Button';
import Icon from 'presentations/views/components/atoms/Icon';
import Progress from 'presentations/views/components/atoms/Progress';
import { spacing, fontWeight } from 'presentations/views/styles';

type Props = {
  isLoading: boolean;
  onClick: () => void;
};

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  return (
    <StyledButton onClick={props.onClick} variant="text">
      {props.isLoading ? (
        <Progress />
      ) : (
        <>
          <Icon name="chevron-down" size="24" color="primary" />
          <StyledText>{t('text')}</StyledText>
        </>
      )}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  background-color: transparent !important;
`;
const StyledText = styled.div`
  margin-left: ${spacing(6)};
  font-weight: ${fontWeight('normal')};
`;
